import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  imageSrc: string;
}
export function TestimonialCard({
  quote,
  author,
  role,
  imageSrc
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5
  }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300" data-id="element-27">
      <div className="flex gap-1 mb-4" data-id="element-28">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-29" />)}
      </div>
      <p className="text-gray-700 mb-6 font-sans leading-relaxed text-sm md:text-base" data-id="element-30">
        "{quote}"
      </p>
      <div className="flex items-center gap-3 pt-4 border-t border-gray-100" data-id="element-31">
        <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-200 flex-shrink-0" data-id="element-32">
          <img src={imageSrc} alt={author} className="w-full h-full object-cover" loading="lazy" decoding="async" width="100" height="100" data-id="element-33" />
        </div>
        <div data-id="element-34">
          <p className="font-bold text-gray-900 text-sm" data-id="element-35">{author}</p>
          <p className="text-xs text-gray-500 font-sans" data-id="element-36">{role}</p>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-50" data-id="element-37">
        <p className="text-[10px] text-gray-400 font-sans" data-id="element-38">
          Verified Purchase • {Math.floor(Math.random() * 30 + 10)} days ago
        </p>
      </div>
    </motion.div>;
}